import { useContext, useState } from "react";
import "./style.css";
import MainButton from "../MainButton/MainButton";
import React from "react";
import Input from "../../Common/Input/Input";
import { popupContext } from "../../../contextAdmin/Admin/Popup";
import { listControllerContext } from "../../../contextAdmin/Admin/List";
import adminRequets from "../../api/adminRequests";

// Creator : Team E - Ariel
export default function Addteacherpopup() {
    const { setPopup } = useContext(popupContext);
    const { list, setList } = useContext(listControllerContext);
    const [message, setMessage] = useState("")
    const [formVals, setformVals] = useState({ fullName: "", email: "", role: "teacher", pass: "" })
    console.log("🚀 ~ file: index.js:19 ~ Addteacherpopup ~ formVals:", formVals)
    const isFormValid = () => {
        const { fullName, role, email, pass } = formVals;

        const fullNameRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z])$/;
        const roleRegex = /^(admin|teacher)$/;
        const emailRegex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+\.[a-zA-z]{2,3}$/;
        const passRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;
        let isValid = fullName
            // && fullName.match(fullNameRegex)
            && role
            // && role.match(roleRegex)
            && email
            // && email.match(emailRegex)
            && pass
        // && pass.match(passRegex);
        console.log(fullName?.match(fullNameRegex), role?.match(roleRegex), email?.match(emailRegex), pass?.match(passRegex), isValid)
        return isValid
    };

    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setformVals((currentFormData) => {
            return {
                ...currentFormData,
                [name]: value,
            };
        });
    };

    function closePopup(e) {
        e.preventDefault();
        setPopup(false);
    }

    async function addTeacher(datails) {
        console.log("🚀 ~ addTeacher ~ datails:", datails)
        try {
            let newUser = await adminRequets.createNewTeacher(datails)
            setMessage("the user added successfully");
            let newTeachersList = await adminRequets.getAllTeachers()
            setList(newTeachersList)
            setTimeout(() => {
                setPopup(false)

            }, 1000)
        } catch (error) {
            console.log("🚀 ~ file: index.js:75 ~ addTeacher ~ error:", error)
            setMessage(error.code)
        }
    }
    const onSubmit = (e) => {
        e.preventDefault();
        if (isFormValid()) {
            addTeacher(formVals)
        }
        // const data = Object.fromEntries(new FormData(formData));
        // console.log(data);

        // fetch(url,{method: 'POST', data: JSON.stringify(formData)})
        // .then(()=>{
        //     alert("Teacher added successfully");
        //     //send email to teacher
        // })
    };

    // <input name="username" id="username" pattern="[A-Za-z0-9]+">
    return (
        <>
            <div>

                <form onSubmit={onSubmit}>
                    <div>
                        <Input legend={"Teacher Name"} value={formVals.fullName} name="fullName" onChange={handleInput} valid={"yes"} type={"text"} requierd={true} />
                        <Input legend={"Teacher Email ID"} value={formVals.email} name="email" onChange={handleInput} valid={"yes"} type={"email"} requierd={true} />
                        <Input legend={"Role"} value={formVals.role} name="role" onChange={handleInput} valid={"yes"} type={"select"} options={["teacher", "admin"]} placeholder={"yos/teacher"} requierd={true} />
                        <Input legend={"Password (8 chars min.)"} value={formVals.pass} name="pass" onChange={handleInput} valid={"yes"} type={"password"} pattern={".{8,}"} autoComplete="new-password" requierd={true} />
                    </div >

                    <div className="popup-fotter">
                        <button className="btn" type="button" onClick={closePopup}>
                            Cancel
                        </button>
                        <button type="submit" className="btn" disabled={!isFormValid()}>{"Add"}</button>
                    </div>

                </form>
                {message && <span style={{ color: "orange" }}>{message}</span>}
            </div>
        </>
    );
}